import Utils from '../../../utils';

import vertexShader from '../../../rendering/shaders/panoramaBackground.vs';
import fragmentShader from '../../../rendering/shaders/panoramaBackground.fs';



const BASIC_MATERIAL_HORIZONTAL_SEGMENTS = 64;
const BASIC_MATERIAL_VERTICAL_SEGMENTS = 32;

const RenderOrderBias = Math.round(Number.MIN_SAFE_INTEGER/2);

class Panorama {
    constructor() {
        const basicMat = !Q3.browserCapabilities.supports.panorama.preciseMaterial.enabled;

        const horizontalSegments = basicMat ? BASIC_MATERIAL_HORIZONTAL_SEGMENTS : 4;
        const verticalSegments = basicMat ? BASIC_MATERIAL_VERTICAL_SEGMENTS : 2;

        this._geometry = new THREE.SphereBufferGeometry(100, horizontalSegments, verticalSegments, 0, -Math.PI * 2);
        this._material = new THREE.ShaderMaterial({
            defines: {
                USE_GEOMETRY_UV: basicMat,
                TEST_UV: Utils.queryParams.has('debug_panorama_uv'),
            },

            uniforms: {
                map: { value: null },
                opacity: { value: 0.0 },
            },

            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            //side: THREE.BackSide,
            transparent: true,
            depthWrite: false,
            visible: false,
        });

        this._object = new THREE.Mesh(this._geometry, this._material);

        this._renderOrder = 0;
        this._updateRenderOrder();

        this._object.frustumCulled = false;
        this._object.isBackground = true;
    }

    get opacity() { return this._material.uniforms.opacity.value; }
    set opacity(value) { this._material.uniforms.opacity.value = value; }

    get object() { return this._object; }

    get renderOrder() { return this._renderOrder; }

    set renderOrder(order) {
        /*if (order < 0) {
            throw new Error('negative render order not allowed');
        }*/

        this._renderOrder = order;
        this._updateRenderOrder();
    }

    _updateRenderOrder() {
        this._object.renderOrder = RenderOrderBias+this._renderOrder;
    }

    setTexture(texture) {
        if (texture) {
            this._material.uniforms.map.value = texture;
            this._material.visible = true;
        } else {
            this._material.visible = false;
        }
    }
}

export default Panorama;
export { Panorama };
